module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/3 a Hovezi krk rozbourany.jpg";